import type { ArTab } from './types';

export const GROWTH_ARTICLES_META = {
  eyebrow: 'SEO · Content',
  titleLead: 'The Organic',
  titleAccent: 'Authority Builder',
  description:
    "ELVA generates targeted, long-tail articles to close your local keyword gaps. By dominating these specific niche clusters, you build the topical authority required to win your market's highly competitive, high-ticket search terms.",
} as const;

export const AR_TABS: readonly { id: ArTab; label: string }[] = [
  { id: 'new', label: 'New Articles' },
  { id: 'existing', label: 'Update Existing' },
  { id: 'calendar', label: 'Content Calendar' },
] as const;
